import React, { useContext } from 'react';
import {
    useFloating,
    useDismiss,
    useRole,
    useClick,
    useInteractions,
    FloatingFocusManager,
    FloatingOverlay,
    FloatingPortal,
} from '@floating-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from 'icons';
import { Config } from 'config';
import { MyDNVContext } from 'mydnv/context/mydnv-context';

export const LoginSignupModal = (props) => {
    const { action } = props;

    const { refs, context } = useFloating({
        open: props.isOpen,
        onOpenChange: props.setModalOpen,
    });
    const click = useClick(context);
    const role = useRole(context);
    const dismiss = useDismiss(context, { outsidePressEvent: 'mousedown' });
    const { getFloatingProps } = useInteractions([click, role, dismiss]);
    const { InteractionStatusNone, isAuthenticated, instance, inProgress } = useContext(MyDNVContext);

    const SignInRequest = Config.MyDNV.loginRequest;
    const SignUpRequest = Config.MyDNV.signUpRequest;

    const login = (request) => {
        // log session storage
        localStorage.setItem('signin-redirect-action', action);

        // debug(webpage, model, error);
        if (!isAuthenticated && inProgress === InteractionStatusNone) {
            instance.loginRedirect(request).catch((e) => {
                console.log(e);
            });
        }
    };

    return (
        <>
            <FloatingPortal>
                {props.isOpen && (
                    <FloatingOverlay className='modal-overlay' lockScroll>
                        <FloatingFocusManager context={context}>
                            <div className='modal' ref={refs.setFloating} {...getFloatingProps()}>
                                <div className='close-btn-wrapper'>
                                    <button onClick={() => props.setModalOpen(false)} className='modal-close'>
                                        <FontAwesomeIcon icon={icons.solid.faXmark} />
                                    </button>
                                </div>
                                <h2>Create a MyDNV account</h2>

                                <p>
                                    Personalize your experience on our website with a MyDNV account. Access features
                                    like bookmarks, subscriptions, and more to stay informed and engaged with municipal
                                    services.
                                </p>
                                <div className='button-wrapper'>
                                    <button className='btn' onClick={() => login(SignUpRequest)}>
                                        Sign up
                                    </button>
                                    or
                                    <button className='btn outline' onClick={() => login(SignInRequest)}>
                                        Log in
                                    </button>
                                </div>
                            </div>
                        </FloatingFocusManager>
                    </FloatingOverlay>
                )}
            </FloatingPortal>
        </>
    );
};
